import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33bf762c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeline-container text-white" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Czekamy na: ", -1))
const _hoisted_3 = { class: "subtext-fadein" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasNextPhase)
      ? (_openBlock(), _createElementBlock("p", {
          key: _ctx.nearestPhaseName,
          class: "p-0 m-0 subtext"
        }, [
          _hoisted_2,
          _createTextVNode(_toDisplayString(_ctx.nearestPhaseName) + " ", 1),
          _createElementVNode("span", _hoisted_3, "o " + _toDisplayString(_ctx.nearestPhaseTime) + " (" + _toDisplayString(_ctx.nearestPhaseTimeTo) + ")", 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}